import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import ApplicationStatusBadge from "./ApplicationStatusBadge";

// One row in the left-hand list — name on top, city/email as the secondary
// line, status badge on the side. Selecting a row is local state only, no
// navigation (mirrors a chat-app conversation list).
export default function ApplicationListItem({ application, selected, onClick }) {
  const name = application.user?.name || application.therapist?.therapist_name || "Unnamed applicant";
  const secondary = [application.practice_city, application.user?.email].filter(Boolean).join(" · ");
  const initial = (name || "?").charAt(0).toUpperCase();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        px: 1.5,
        py: 1.25,
        cursor: "pointer",
        borderRadius: 1.5,
        mx: 0.75,
        mb: 0.25,
        bgcolor: selected ? "#FFFFFF" : "transparent",
        boxShadow: selected ? "0 1px 2px rgba(16,24,40,0.06)" : "none",
        "&:hover": { bgcolor: "#FFFFFF" },
      }}
    >
      <Avatar sx={{ width: 34, height: 34, bgcolor: "#0058a5", fontSize: "0.8125rem", fontWeight: 600, flexShrink: 0 }}>
        {initial}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography noWrap sx={{ fontSize: "0.8125rem", fontWeight: 600, color: "#111827", lineHeight: 1.3 }}>
          {name}
        </Typography>
        <Typography noWrap sx={{ fontSize: "0.75rem", color: "#6b7280", lineHeight: 1.4 }}>
          {secondary || "-"}
        </Typography>
      </Box>
      <ApplicationStatusBadge status={application.status} />
    </Box>
  );
}
